"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.runCommonValidation = exports.messages = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var nameRegex = /^[a-z ,.'-]{2,}$/i;
var requiredRegex = /\S/;
var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
var phoneRegex = /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/;
var zipRegex = /^(\d{5})?$/;
var pwRegex = /^((?=.*[A-Z])(?=.*[a-z])(?=.*\d).*|(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).*|(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).*|(?=.*[A-Z])(?=.*[a-z])(?=.*[^A-Za-z0-9]).*)$/;
var messages = exports.messages = {
  firstNameMissing: 'Please provide a first name.',
  firstNameMinimum: 'First name should be at least 2 letters.',
  firstNameInvalid: 'First name cannot contain numbers or symbols.',
  lastNameMissing: 'Please provide a last name.',
  lastNameMinimum: 'Last name should be at least 2 letters.',
  lastNameInvalid: 'Last name cannot contain numbers or symbols.',
  fullNameMissing: 'Please provide a name.',
  fullNameMinimum: 'Name should be at least 2 letters.',
  fullNameInvalid: 'Name cannot contain numbers or symbols.',
  nameMinimum: 'Name should be at least 2 letters.',
  nameInvalid: 'Name cannot contain numbers or symbols.',
  emailMissing: 'Please provide an email address.',
  emailInvalid: 'Email should be in the format email@domain.com.',
  emailRulesMatching: 'Email and confirm email must match.',
  phoneMissing: 'Please provide a phone number.',
  phoneInvalid: 'Phone number should be a US number (with area code).',
  zipMissing: 'Please provide a zip code.',
  zipInvalid: 'Zip code should be 5 numbers.',
  passwordRulesCharacters: 'Passwords must contain at least 3 of the following: uppercase, lowercase, number or special character.',
  passwordRulesMatching: 'New and confirm passwords must match.',
  passwordMissing: 'Please enter a valid password.',
  agreeToTerms: 'Please accept the terms and conditions.'
};
var runCommonValidation = exports.runCommonValidation = function runCommonValidation(formState, customMessages) {
  var formErrors = {};
  var errorMessages = _objectSpread(_objectSpread({}, messages), customMessages);
  if (formState.email && formState.email.touched) {
    if (!requiredRegex.test(formState.email.value.trim())) {
      if (!formState.email.notRequired) {
        formErrors.email = errorMessages.emailMissing;
      }
    } else if (!emailRegex.test(formState.email.value.trim())) {
      formErrors.email = errorMessages.emailInvalid;
    }
  }
  if (formState.confirmEmail && formState.confirmEmail.touched) {
    if (formState.email.value.toLowerCase() !== formState.confirmEmail.value.toLowerCase()) {
      formErrors.confirmEmail = errorMessages.emailRulesMatching;
    }
  }
  if (formState.name && formState.name.touched) {
    if (!requiredRegex.test(formState.name.value.trim())) {
      if (!formState.name.notRequired) {
        formErrors.name = errorMessages.fullNameMissing;
      }
    } else if (formState.name.value.trim().length < 2) {
      formErrors.name = errorMessages.fullNameMinimum;
    } else if (!nameRegex.test(formState.name.value.trim())) {
      formErrors.name = errorMessages.fullNameInvalid;
    }
  }
  if (formState.firstName && formState.firstName.touched) {
    if (!requiredRegex.test(formState.firstName.value.trim())) {
      if (!formState.firstName.notRequired) {
        formErrors.firstName = errorMessages.firstNameMissing;
      }
    } else if (formState.firstName.value.trim().length < 2) {
      formErrors.firstName = errorMessages.firstNameMinimum;
    } else if (!nameRegex.test(formState.firstName.value.trim())) {
      formErrors.firstName = errorMessages.firstNameInvalid;
    }
  }
  if (formState.lastName && formState.lastName.touched) {
    if (!requiredRegex.test(formState.lastName.value.trim())) {
      if (!formState.lastName.notRequired) {
        formErrors.lastName = errorMessages.lastNameMissing;
      }
    } else if (formState.lastName.value.trim().length < 2) {
      formErrors.lastName = errorMessages.lastNameMinimum;
    } else if (!nameRegex.test(formState.lastName.value.trim())) {
      formErrors.lastName = errorMessages.lastNameInvalid;
    }
  }
  if (formState.zip && formState.zip.touched) {
    if (!requiredRegex.test(formState.zip.value.trim())) {
      if (!formState.zip.notRequired) {
        formErrors.zip = errorMessages.zipMissing;
      }
    } else if (!zipRegex.test(formState.zip.value.trim())) {
      formErrors.zip = errorMessages.zipInvalid;
    }
  }
  if (formState.phone && formState.phone.touched) {
    if (!requiredRegex.test(formState.phone.value.trim())) {
      if (!formState.phone.notRequired) {
        formErrors.phone = errorMessages.phoneMissing;
      }
    } else if (!phoneRegex.test(formState.phone.value.trim())) {
      formErrors.phone = errorMessages.phoneInvalid;
    }
  }
  if (formState.currentPassword && formState.currentPassword.touched) {
    if (!requiredRegex.test(formState.currentPassword.value.trim())) {
      formErrors.currentPassword = errorMessages.passwordMissing;
    }
  }
  if (formState.password && formState.password.touched) {
    if (!requiredRegex.test(formState.password.value.trim())) {
      formErrors.password = errorMessages.passwordMissing;
    } else if (!pwRegex.test(formState.password.value)) {
      formErrors.password = errorMessages.passwordRulesCharacters;
    }
  }
  if (formState.confirmPassword && formState.confirmPassword.touched) {
    if (formState.password.value !== formState.confirmPassword.value) {
      formErrors.confirmPassword = errorMessages.passwordRulesMatching;
    }
  }
  if (formState.termsConditions && formState.termsConditions.touched) {
    if (!formState.termsConditions.value) {
      formErrors.termsConditions = errorMessages.agreeToTerms;
    }
  }
  formErrors.hasErrors = Object.keys(formErrors).filter(function (k) {
    return !!formErrors[k];
  }).length > 0;
  return formErrors;
};